import { format } from 'date-fns';
import { useCallback, useContext, useMemo } from 'react';
import { DateContext } from '../../Core/Contexts/DateContext';
import { LocationContext } from '../../Core/Contexts/LocationContext';
import { useGetProductionOrders } from '../../Core/Hooks/OrderBookHooks';
import { useGetLocation } from '../../Core/Hooks/LocationHooks';
import { Props } from './ProductionOrdersTable';

type AdditionalProps = {
	isFetching: boolean;
	refresh: () => Promise<void>;
	handleOrderClick: () => void;
};

export const useProductionOrdersTableData = (): Props & AdditionalProps => {
	const [selectedDate] = useContext(DateContext);
	const [selectedLocation] = useContext(LocationContext);

	const {
		data: currentLocation,
		isLoading: isLocationLoading,
		isFetching: isLocationFetching,
		refetch: refetchLocation,
	} = useGetLocation(selectedLocation);

	const {
		data: orders,
		isLoading: areProductionOrdersLoading,
		isFetching: areProductionOrdersFetching,
		refetch: refetchProductionOrders,
	} = useGetProductionOrders(
		format(selectedDate[0], 'yyyy-MM-dd')
	);

	const isLoading = useMemo(
		() => isLocationLoading || areProductionOrdersLoading,
		[areProductionOrdersLoading, isLocationLoading]
	);
	const isFetching = useMemo(
		() => isLocationFetching || areProductionOrdersFetching,
		[areProductionOrdersFetching, isLocationFetching]
	);

	const refresh = useCallback(() => {
		return (
			Promise.all([refetchLocation(), refetchProductionOrders()])
				// We want to return void
				.then(() => {
				})
		);
	}, [refetchProductionOrders, refetchLocation]);

	const handleOrderClick = useCallback(() => {}, []);

	return {
		currentLocation,
		orders,
		isLoading,
		isFetching,
		refresh,
		handleOrderClick
	};
};
